import { Link } from 'react-router-dom';
import { CHISIAMO_TAB, CONTATTI_TAB, MENU_TAB } from '../utilities/Constants';
import LogoImage from '../assets/img/logo.png';

const NavBar = ({ activeItem }) => {
  return (
    <nav className="navbar navbar-expand-lg bg-body-tertiary colore-secondario">
      <div className="container d-flex">
        <Link className="navbar-brand d-flex mx-auto text-center" to="/">
          <img src={LogoImage} alt="Pizzeria" className="logo rounded-circle" />
        </Link>
        <div className="navbar-collapse justify-content-center">
          <ul className="navbar-nav text-center text-lg-start">
            <li className="nav-item">
              <Link
                className={`btn btn-primary btn-lg rounded me-lg-2 mb-2 mb-lg-0 button-primary-pers shadow-lg ${
                  activeItem === MENU_TAB ? 'nav-active' : ''
                }`}
                aria-current={activeItem === MENU_TAB ? 'page' : undefined}
                to="/menu"
              >
                Menu
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className={`btn btn-primary rounded btn-lg me-lg-2 mb-2 mb-lg-0 button-primary-pers shadow-lg ${
                  activeItem === CHISIAMO_TAB ? 'nav-active' : ''
                }`}
                aria-current={activeItem === CHISIAMO_TAB ? 'page' : undefined}
                to="/about"
              >
                Chi Siamo
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className={`btn btn-primary rounded btn-lg navbar-text button-primary-pers shadow-lg ${
                  activeItem === CONTATTI_TAB ? 'nav-active' : ''
                }`}
                aria-current={activeItem === CONTATTI_TAB ? 'page' : undefined}
                to="/contatti"
              >
                Contatti
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;